import { useEffect } from 'react';

// Injects a <script type="application/ld+json"> tag into <head> for the
// lifetime of the component. react-helmet was avoided here because it
// throws during render under React 18 StrictMode in development.
const useJsonLd = (schema) => {
  const json = schema != null ? JSON.stringify(schema) : null;

  useEffect(() => {
    if (!json) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = json;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [json]);
};

export default useJsonLd;
